import React, { useEffect } from "react";
import createPersistedState from "use-persisted-state";
import Recursive from "../../Recursive";
import GlobalState from "../../useGlobalState";

const useTreeData = createPersistedState("preview");

export default function Preview() {
  const { state, dispatch } = GlobalState.useContainer();

  const [stateInLocalStorage] = useTreeData();
  useEffect(() => {
    dispatch({
      type: "REPLACE_WHOLE_STATE",
      payload: {
        newState: stateInLocalStorage,
      },
    });
  }, [stateInLocalStorage]);

  return (
    <>
      {state.treeData.map((branch) => (
        <Recursive babies={branch.children} {...branch} key={branch.id} allTreeAttritbutes={state.attributes} />
      ))}
    </>
  );
}
